/**
 * Thin adapter for itinerary load/save across consumer trips and TP client trips.
 */

import type { Client, Trip } from '../types/client';
import {
  getClient,
  updateTrip as updateClientTrip,
  pushClientsToBackend,
} from './clientsService';
import {
  getTrip as getUserTrip,
  updateTrip as updateUserTrip,
  pushTripsToBackend,
} from './tripsService';

export interface PlanContext {
  mode: 'pro' | 'user';
  userId: string;
  tripId: string;
  clientId?: string;
}

export function loadPlanTrip(ctx: PlanContext): { client: Client | null; trip: Trip | null } {
  if (ctx.mode === 'user') {
    return { client: null, trip: getUserTrip(ctx.userId, ctx.tripId) };
  }
  if (!ctx.clientId) return { client: null, trip: null };
  const client = getClient(ctx.userId, ctx.clientId);
  const trip = client?.trips?.find((t) => t.id === ctx.tripId) ?? null;
  return { client, trip };
}

export function savePlanTrip(
  ctx: PlanContext,
  updates: Partial<Omit<Trip, 'id'>>
): Trip | null {
  if (ctx.mode === 'user') {
    return updateUserTrip(ctx.userId, ctx.tripId, updates);
  }
  if (!ctx.clientId) return null;
  return updateClientTrip(ctx.userId, ctx.clientId, ctx.tripId, updates);
}

export function pushPlanData(ctx: PlanContext): void {
  if (ctx.mode === 'user') {
    pushTripsToBackend(ctx.userId);
  } else {
    pushClientsToBackend(ctx.userId);
  }
}
